import React from 'react';
import { Stack, useTheme } from '@mui/material';
import { VTypography } from '@venti-components';
import VSelectInput from '../../../../Venti-UI-Kit/VInputs/VSelectInput/VSelectInput';
import VAutocomplete from '../../../../Venti-UI-Kit/VAutocomplete/VAutocomplete';
import { useAuth } from '../../../../Providers/AuthProvider/AuthProvider';
import permissions from '../../../../Providers/Permissions/Permissions';
import VFormCard from '../../../../Venti-UI-Kit/VForms/VFormCard/VFormCard';
import useOrganizers from '../../../../hooks/useOrganizers';
import OrganizerCard from '../../../ProducerComponents/OrganizerCard';
import AutocompleteOption from '../../../ProducerComponents/ProducerOption';

const VISIBILITY_OPTIONS = [
  { value: 'public', label: 'Público' },
  { value: 'hidden', label: 'Oculto' },
];

const OrganizerForm = ({ formState, onChange }) => {
  const { user } = useAuth();
  const theme = useTheme();
  const {
    organizers,
    isLoading,
    searchProducers,
    handleOrganizerSelect,
    removeOrganizerFromProducer,
  } = useOrganizers();

  // Only show the form for super-admins
  if (!permissions.isSuperAdmin(user?.role) || isLoading) {
    return null;
  }

  return (
    <VFormCard label="Configuración de Organizadores">
      <VSelectInput
        title="Visibilidad"
        name="visibility"
        value={formState?.visibility?.value}
        options={VISIBILITY_OPTIONS}
        onChange={onChange}
        errorText={formState?.visibility?.error}
        helperText="Controla si este organizador es visible públicamente"
      />

      <Stack>
        <VTypography variant="subtitle1" fontWeight={500}>
          Representantes
        </VTypography>

        {organizers.length === 0 && (
          <VTypography variant="body2">
            No hay organizadores asignados a esta productora
          </VTypography>
        )}

        {organizers.length > 0 && (
          <Stack gap={1}>
            <VTypography variant="body2" color={theme.palette.text.secondary}>
              Los eventos que cree esta productora aparecerán bajo el nombre de estos organizadores:
            </VTypography>
            <Stack gap={1} mt={1} mb={2} alignItems="flex-start" direction="row">
              {organizers.map((organizer) => (
                <OrganizerCard
                  key={organizer.id}
                  organizer={organizer}
                  onRemove={removeOrganizerFromProducer}
                />
              ))}
            </Stack>
          </Stack>
        )}

        <Stack gap={1} mt={1}>
          <Stack>
            <VTypography variant="subtitle1" fontWeight={500}>
              Agregar Representante
            </VTypography>
            <VTypography variant="body2" color={theme.palette.text.secondary}>
              Busca y selecciona un organizador representante para agregar a esta productora
            </VTypography>
          </Stack>
          <VAutocomplete
            onSelectOption={handleOrganizerSelect}
            searchFunction={searchProducers}
            optionLabelKey="name"
            placeholder="Buscar organizadores..."
            noOptionsText="No se encontraron organizadores"
            loadingText="Buscando organizadores..."
            customOptionComponent={AutocompleteOption}
          />
        </Stack>
      </Stack>
    </VFormCard>
  );
};

export default OrganizerForm;
